"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalizationWrapper = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const web_i18n_1 = require("@snapchat/web-i18n");
const react_intl_1 = require("react-intl");
const messageLoader_1 = require("../i18n/messageLoader");
/**
 * Localization Layer to be added on top of Navigation components
 */
function LocalizationWrapper(props) {
    const { locale: defaultLocale, messages: defaultMessages, children } = props;
    const { locale, messages } = (0, web_i18n_1.useLocale)({
        defaultLocale,
        defaultMessages,
        loadMessages: messageLoader_1.loadMessages,
    });
    return ((0, jsx_runtime_1.jsx)(react_intl_1.IntlProvider, { locale: locale, defaultLocale: props.locale ?? web_i18n_1.Locale.enUS, messages: messages, children: children }));
}
exports.LocalizationWrapper = LocalizationWrapper;
//# sourceMappingURL=LocalizationWrapper.js.map